import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null); // null = checking; false = not authed; obj = authed
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                // silently probe session; suppress 401 console noise on public pages
                const { data } = await api.get("/auth/me", { validateStatus: (s) => s < 500 });
                if (data && data.email) setUser(data); else setUser(false);
            } catch {
                setUser(false);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setUser(data);
        return data;
    };

    const logout = async () => {
        try { await api.post("/auth/logout"); } catch {}
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
